import { type Scope, createContextScope } from '@radix-ui/react-context'

import type { InputMultiSelectContextData } from './input-multi-select.types'

enum DisplayNames {
  ROOT = 'InputMultiSelect',
  LABEL = 'InputMultiSelectLabel',
  CONTROL = 'InputMultiSelectControl',
  HELPER_TEXT = 'InputMultiSelectHelperText',
  CHIP = 'InputMultiSelectChip',
  DROPDOWN_LIST = 'InputMultiSelectDropdownList',
  CLEAR_BUTTON = 'InputMultiSelectClearButton',
}

type ScopedProps<P> = P & {
  __scopeInputMultiSelect?: Scope
}

const [createInputMultiSelectContext] = createContextScope(DisplayNames.ROOT)

const [InputMultiSelectProvider, useInputMultiSelectContext] =
  createInputMultiSelectContext<InputMultiSelectContextData>(DisplayNames.ROOT)

export { DisplayNames, InputMultiSelectProvider, useInputMultiSelectContext }
export type { ScopedProps }
